//@flow
import {S3BUCKET, ZOOM_S3} from '../util/Constants';
import {RepoItem, UploadFromUrlQuery} from '../autogenerated/ZoomBridge';

export default class S3Action {
  actionType: string; //Either S3Bucket or Public Link
  s3BucketName: string;
  s3BucketPath: string;
  s3AccessId: string;
  s3AccessKey: string;
  zoomDist: string;
  sameNameFileOp: string;
  urls: Array<string>;
  linkExpireOption: string;
  selectedAssets: Array<RepoItem>;

  constructor(actionType: string = S3BUCKET) {
    this.actionType = actionType;
  }

  setActionType(actionType: string): void {
    this.actionType = actionType;
  }
  setS3BucketName(s3BucketName: string): void {
    this.s3BucketName = s3BucketName;
  }
  setS3BucketPath(s3BucketPath: string): void {
    this.s3BucketPath = s3BucketPath;
  }
  setS3AccessId(s3AccessId: string): void {
    this.s3AccessId = s3AccessId;
  }
  setS3AccessKey(s3AccessKey: string): void {
    this.s3AccessKey = s3AccessKey;
  }
  setZoomDist(zoomDist: string): void {
    this.zoomDist = zoomDist;
  }
  setSameNameFileOp(sameNameFileOp: string): void {
    this.sameNameFileOp = sameNameFileOp;
  }
  setUrls(urls: Array<string>): void {
    this.urls = urls;
  }
  setLinkExpireOption(linkExpireOption: string): void {
    this.linkExpireOption = linkExpireOption;
  }
  setSelectedAssets(assets: Array<RepoItem> = []) {
    this.selectedAssets = assets;
  }

  run(): Promise<{success: boolean}> {
    return new Promise((onSuccess, onFailure) => {
      onSuccess({success: true})
      // const uploadFromUrlQuery:UploadFromUrlQuery = new UploadFromUrlQuery();
      // // const authenticator = 
    });
  }
}
